import { EntityRefUtil, type GetUsersRequestDTO } from '@gearbelt/global';

import { ApiService } from '@/services/api-v2';

export type UserOption = { label: string; value: string; avatarUrl?: string };

type UserTypeFilter = NonNullable<GetUsersRequestDTO['filters']>['userType'];

export async function loadUserOptions(input: string, userType: UserTypeFilter, onError?: () => void): Promise<UserOption[]> {
  try {
    const { data } = await (
      await ApiService.GetUsers({
        // A page size for the server-side search, not tied to the API's user summary batch size.
        limit: 100,
        filters: { search: input, userType },
      })
    ).json();

    return (
      data?.map((user) => ({
        value: user.id,
        label: EntityRefUtil.createUserFullNameRef(user),
        avatarUrl: user.avatarUrl ?? undefined,
      })) ?? []
    );
  } catch {
    onError?.();
    return [];
  }
}
